import React from 'react';
import ReactModal from 'react-modal';

// DEPRECATED: don't use this one, use SalonModal
class AlertDialog extends React.Component {
  static defaultProps = {
    children: [],
    onClick: () => {},
    onClose: () => {},
  };
  state = {
    isShowingModal: true,
  };
  handleClick = () => {
    this.setState({ isShowingModal: false });
    if (this.props.onClick) {
      this.props.onClick();
    }
  };
  handleClose = () => {
    this.setState({ isShowingModal: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const { title, buttonText } = this.props;
    return (
      <ReactModal
        isOpen={this.state.isShowingModal}
        onRequestClose={this.handleClose}
        closeTimeoutMS={0}
        contentLabel={title}
        ariaHideApp
        shouldCloseOnOverlayClick
        role="dialog"
        style={{ overlay: { zIndex: 500 } }}
        className={{ base: 'dialog-container', afterOpen: 'dialog-container', beforeClose: 'dialog-container' }}
      >
        <div data-bem="AlertDialog" className="dialog">
          <div data-bem="AlertDialog__header" className="dialog-header">
            <h2 data-bem="AlertDialog__title">{title}</h2>
          </div>
          <div data-bem="AlertDialog__body" className="body">
            {this.props.children}
          </div>
          <div data-bem="AlertDialog__footer" className="dialog-footer">
            <div data-bem="AlertDialog__button" data-cy="alert-button" className="btn btn-violet-link" onClick={this.handleClick} role="button" tabIndex={0}>
              {buttonText}
            </div>
          </div>
        </div>
      </ReactModal>
    );
  }
}

export default AlertDialog;
